export const THUMBNAIL_NAVIGATOR_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ThumbnailNavigatorWidgetElement';
